import gql from 'graphql-tag';

export const EDIT_POST = gql`
  mutation update_posts_by_pk(
    $id: uuid!
    $content: String
    $publish_time: timestamptz
    $status: post_status_enum
    $mobile_body: String
    $parse_body: String
    $image_path: String
    $image_url: String
  ) {
    update_posts_by_pk(
      pk_columns: { id: $id }
      _set: {
        content: $content
        publish_time: $publish_time
        status: $status
        mobile_body: $mobile_body
        parse_body: $parse_body
        image_path: $image_path
        image_url: $image_url
      }
    ) {
      id
      image_url
    }
  }
`;
